module.exports = __webpack_public_path__ + "img/utility-impostor.24836231.png";